import { render } from "./av-time.vue?vue&type=template&id=13cfb825&ts=true"
import script from "./av-time.vue?vue&type=script&lang=ts"
export * from "./av-time.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/.pnpm/vue-loader@17.0.1_@vue+compiler-sfc@3.5.16_vue@3.5.16_typescript@4.8.4__webpack@5.84.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__